import React from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { Stories } from "./stories";
import { DfpComponent } from "../../../ads/dfp-component";

import "./right-section.m.css";

const RightSection = ({ showYourMoneyStories = true, showLatestStories = true, add350x250 = true }) => {
  const sideAd1 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sidebar_right_1"], {}));
  const sideAd2 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sidebar_right_2"], {}));
  const sideAd3 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sidebar_right_3"], {}));

  return (
    <div styleName="right-section">
      <div styleName="right-top-ad-slot">
        <DfpComponent adStyleName="ad-slot-size-300x600" id={sideAd1?.id} />
      </div>

      {showYourMoneyStories && (
        <div styleName="your-money-stories-section">
          <Stories collectionName="your-money" title="YOUR MONEY" />
        </div>
      )}

      {showYourMoneyStories && (
        <div styleName="right-middle-ad-slot">
          <DfpComponent adStyleName="ad-slot-size-300x250-constant" id={sideAd2?.id} />
        </div>
      )}

      {showLatestStories && (
        <div styleName="latest-stories-section">
          <Stories collectionName="latest-stories" title="LATEST STORIES" />
        </div>
      )}

      {add350x250 && (
        <div styleName="right-bottom-ad-slot">
          <DfpComponent adStyleName="ad-slot-size-300x250-constant" id={sideAd3?.id} />
        </div>
      )}
    </div>
  );
};

export default RightSection;
